<template>
  <div id="login">
    <div class="upper">
      <div class="logo">
        <img src="@/assets/se_text_logo.png" width="200" >
      </div>
      <form class="form" @submit.prevent="loginUser()">
        <span class="p-input-icon-left">
          <i class="pi pi-user" />
          <InputText type="text" v-model="email" placeholder="Email" />
        </span>
        <span class="p-input-icon-left">
          <i class="pi pi-lock" />
          <InputText type="password" v-model="password" placeholder="Password" />
        </span>
        <Button class="login_button" label="Login" type="submit" />
          <router-link class="forgot" to="/forgot">
            Forgot Password?
          </router-link>
      </form>
    </div>
    <div class="lower">
      <router-link to="/signup">CREATE ACCOUNT</router-link>
    </div>
    <Toast position="bottom-right" />
  </div>
</template>

<script>
import { fb_auth } from "../firebase";
export default {
  name: "Login",
  data() {
    return {
      email: null,
      password: null,
    };
  },
  methods: {
    loginUser() {
      if (this.email && this.password) {
        fb_auth
          .signInWithEmailAndPassword(this.email, this.password)
          .then(() => {
            console.log("user:", fb_auth.currentUser);
            this.$router.push({ path: "/orders" });
            //route to dashboard
          })
          .catch((error) => {
            // Handle Errors here.
            var errorCode = error.code;
            if (errorCode == "auth/wrong-password") {
              errorCode = "Incorrect Password";
            }
            var errorMessage = error.message;
            console.log(errorCode, errorMessage);
            this.$toast.add({
              severity: "error",
              summary: "errorcode",
              detail: "Login Message",
              life: 3000,
            });
          });
      } else {
        this.$toast.add({
          severity: "warn",
          summary: "Form Incomplete",
          detail: this.email
            ? "Password cannot be empty."
            : "Email cannot be empty",
          life: 3000,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/theme.scss';

#login {
  background: $primary;

  .upper {
    border-radius: 0px 0px 15px 15px;
    box-shadow: 3px 3px 6px #00000050;
    background: $white;
    padding: 15px;
  }

  form {
    width: 75%;
    margin: 0 auto;
    max-width: 250px;

    .p-input-icon-left {
      margin: 20px 0px;
      width: 100%;
    }

    input {
      width: 100%;
    }
  }

  .login_button {
    width: 100%;
    margin: 20px auto;
    font-weight: 700;
    color: $text;
  }

  .forgot {
    margin: 10px;
  }

  .logo {
    padding: 20px 0px;
  }

  .lower {
    padding: 50px 0px;

    a, a:visited {
      color: white;
      text-decoration: none;
    }
  }
}
</style>